<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent" style="margin-left: 2em; text-indent:-1em;"><a id="piv">pity this busy monster, manunkind,</a></p><a id="piv">
<p class="noindent" style="margin-left: 2em; text-indent:-1em;">not. Progress is a comfortable disease: your victim(death and life safely beyond)</p>
<p class="noindent" style="margin-left: 2em; text-indent:-1em;">plays with the bigness of his littleness—electrons deify one razorblade into a mountainrange; lenses extend</p>
<p class="noindent" style="margin-left: 2em; text-indent:-1em;">unwish through curving wherewhen till unwish returns on its unself.</p>
<p class="noindent" style="margin-left: 2em; text-indent:-1em;">A world of made is not a world of born—pity poor flesh</p>
<p class="noindent" style="margin-left: 2em; text-indent:-1em;">and trees, poor stars and stones, but never this fine specimen of hypermagical</p>
<p class="noindent" style="margin-left: 2em; text-indent:-1em;">ultraomnipotence. We doctors know</p>
<p class="noindent" style="margin-left: 2em; text-indent:-1em;">a hopeless case if—listen: there’s a hell of a good universe next door; let’s go</p>
<p class="right" style="font-size:1em;">—e e cummings</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface001.vue?4e83056a